import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

let sessionExpirySignaled = false;
const SESSION_EXPIRED_EVENT = "palletnext:session-expired";
const isPublicAuthRequest = (url = "") => [
  "/auth/login",
  "/auth/register",
  "/auth/logout",
  "/auth/password-reset",
  "/auth/forgot-password",
  "/auth/verify-email",
].some((path) => String(url).includes(path));

export function resetSessionExpirySignal() {
  sessionExpirySignaled = false;
}

const signalSessionExpired = (requestUrl = "") => {
  if (sessionExpirySignaled || isPublicAuthRequest(requestUrl)) return;
  // /auth/me is also used to discover an anonymous session on first boot.
  // Only treat its 401 as an expired session when a bearer token actually exists.
  if (String(requestUrl).includes("/auth/me") && !localStorage.getItem("pallet_token")) return;
  sessionExpirySignaled = true;
  localStorage.removeItem("pallet_token");
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 45000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pallet_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    const url = response?.config?.url || "";
    if (String(url).includes("/auth/login") || String(url).includes("/auth/me")) {
      resetSessionExpirySignal();
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    if (!error.response) {
      error.friendlyMessage = error.code === "ECONNABORTED"
        ? "Sunucu yanıt vermedi. İşlem zaman aşımına uğradı; lütfen tekrar deneyin."
        : "PalletNext sunucusuna ulaşılamıyor. İnternet bağlantınızı kontrol edip tekrar deneyin.";
    } else if (status === 401) {
      error.friendlyMessage = "Oturumunuz sona ermiş olabilir. Lütfen yeniden giriş yapın.";
      signalSessionExpired(error?.config?.url || "");
    } else if (status === 403) {
      error.friendlyMessage = "Bu işlem için gerekli yetkiniz bulunmuyor.";
    } else if (status === 404) {
      error.friendlyMessage = "İstenen kayıt bulunamadı veya artık mevcut değil.";
    } else if (status === 422) {
      error.friendlyMessage = "Bazı alanlar geçersiz veya eksik. Form bilgilerini kontrol edin.";
    } else if (status >= 500) {
      error.friendlyMessage = "Sunucu tarafında geçici bir sorun oluştu. Verileriniz korunuyor; lütfen tekrar deneyin.";
    }
    return Promise.reject(error);
  },
);

export function formatApiError(detail, fallback) {
  if (detail == null) return fallback || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export function formatRequestError(error, fallback) {
  if (error?.friendlyMessage) return error.friendlyMessage;
  return formatApiError(error?.response?.data?.detail, fallback);
}
